import { offerMeteredTransforms } from "@stores/config/utils";
import { ManageAddOnLink } from "@components/account/plan/ManageAddOns/ManageAddOns.components";
import { IAddOnSlotProps } from "../../types";

export function LegacyTransformsManageLink({
  addOn: { purchase, config, canChangeSubscription, subscribed },
}: IAddOnSlotProps) {
  if (offerMeteredTransforms(config) || !canChangeSubscription) {
    return null;
  }

  return (
    <ManageAddOnLink
      hasAddOn={!!subscribed}
      href={`/account/${purchase.id}/transforms`}
    />
  );
}
